import { ResourceType } from "@/services/cloudchipr.api";
import { RootState } from "@/store/store";
import { selectedResourcesByMasterIdSelector } from "@/store/resources-grid/selectors/grid/selection/selectedResourcesByMasterIdSelector";
import { AllTypeResourceItem } from "@/store/resources-grid/utils/types/resources";
import { generateAutomationFoundResourcesMasterGridId } from "@/components/pages/automations/common/components/found-resources/components/AutomationsFoundResourcesCard";

export const previewSelectedResourcesSelector = (
  state: RootState,
  resourceTypes: ResourceType[],
) => {
  return resourceTypes
    .map((resourceType) => {
      const masterGridId =
        generateAutomationFoundResourcesMasterGridId(resourceType);

      return selectedResourcesByMasterIdSelector(state, masterGridId);
    })
    .flat()
    .filter((resource) => !!resource) as AllTypeResourceItem[];
};
